<script setup lang="ts">
/** FE-014 — redesign shell; the redirect and the sign-in hand-off are unchanged. */
import { FairButton } from '@/ui/primitives/FairButton'
import { useAuthModal } from "@/features/auth/store";
import router from "@/router";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const loadingState = ref(false);

function loginHandler() {
  loadingState.value = true;
  // The redesign renamed this view key; "signIn" only worked via the fallback.
  useAuthModal().showAuthModal("login");
  loadingState.value = false;
}

onMounted(() => {
  router.push({ path: "/" });
});
</script>

<template>
  <div class="fair-auth-screen fair-auth-screen--centered">
    <div class="fair-auth-screen__text-block">
      <h2 class="fair-auth-screen__title">
        {{ t("signup.registration_success") }}
      </h2>
    </div>
    <FairButton
      class="fair-auth-cta"
      size="auto"
      :label="t('signup.sign_in_button')"
      :disabled="loadingState"
      @click="loginHandler"
    />
  </div>
</template>
